import type { DevicePaymentMethod } from "../../../../api/devices";

// Всичко, което модалът за устройство може да промени — пазачът за
// незапазени промени сравнява снимката при отваряне с текущата.
export interface DeviceFormSnapshotValues {
  name: string;
  userIds: number[];
  stationIds: number[];
  printLanguage: string | null;
  paymentMethods: DevicePaymentMethod[];
  summarizeReceipt: boolean;
  nonFiscalCopy: boolean;
  isEnabled: boolean;
}

// Подредбата на избора не е промяна: [1, 2] и [2, 1] са едно и също.
const sortedIds = (ids: number[]) => [...ids].sort((a, b) => a - b);

export const deviceFormSnapshot = (values: DeviceFormSnapshotValues): string =>
  JSON.stringify({
    name: values.name.trim(),
    userIds: sortedIds(values.userIds),
    stationIds: sortedIds(values.stationIds),
    printLanguage: values.printLanguage ?? null,
    paymentMethods: [...values.paymentMethods]
      .map((method) => [method.paymentMethodId, method.value.trim()])
      .sort((a, b) => Number(a[0]) - Number(b[0])),
    summarizeReceipt: values.summarizeReceipt,
    nonFiscalCopy: values.nonFiscalCopy,
    isEnabled: values.isEnabled,
  });
